import { Box, IconButton } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IRuleSet } from '../../../DTStudio/interfaces'
import TruncatedText from '../../../Common/TruncatedText'
import { RuleSummary } from './RuleSummary'
import BusinessRulesLabel from './BusinessRulesLabel'

interface RulePreviewProps {
    ruleSet: IRuleSet
    index: number
    expanded?: boolean
    setExpanded?: React.Dispatch<React.SetStateAction<boolean>>
}

const RuleSetPreview: React.FC<RulePreviewProps> = ({
    ruleSet,
    index,
    expanded,
    setExpanded,
}) => {
    const { rules } = ruleSet
    const { t } = useTranslation()

    return (
        <Box key={ruleSet.id} sx={{ mb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <BusinessRulesLabel
                    text={index === 0 ? t('businessRuleset') : ''}
                />
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: 'calc(60% - 25px)',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        sx={{
                            maxWidth: 'calc(100% - 20px)',
                        }}
                    >
                        <TruncatedText
                            sx={{
                                fontSize: '14px',
                            }}
                            text={ruleSet.name}
                        />
                    </Box>
                    {index === 0 && (
                        <IconButton
                            size="small"
                            onClick={() => setExpanded?.((prev) => !prev)}
                            aria-label={expanded ? 'Collapse' : 'Expand'}
                            sx={{ height: '20.02px', padding: '0px' }}
                        >
                            {expanded ? (
                                <ArrowDropUpIcon fontSize="medium" />
                            ) : (
                                <ArrowDropDownIcon fontSize="medium" />
                            )}
                        </IconButton>
                    )}
                </Box>
            </Box>

            {expanded && <RuleSummary rules={rules} />}
        </Box>
    )
}

export default RuleSetPreview
